import React, { useState } from 'react';
import { TableRowComponent } from './TableRowComponent';

interface IProps {
  moduleData: any;
  handleDelete: any;
  updateModuleData: any;
  machineData?: any;
}
const TBody = ({ handleDelete, moduleData, updateModuleData }: IProps) => {
  return (
    <tbody>
      {moduleData?.list?.map((item: any, index: any) => (
        <TableRowComponent
          key={item?._id || item?._tempId}
          {...{
            item,
            index,
            updateModuleData,
            handleDelete,
          }}
        />
      ))}
    </tbody>
  );
};

export default React.memo(TBody);
